import templateUrl from './helpMenu.html'
import contentTemplateUrl from './helpMenu.content.html'

/**
 * Help Menu component
 *
 * @example
 * <tmr-help-menu></tmr-help-menu>
 *
 * @type {ngComponent}
 */
export const tmrHelpMenu = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrHelpMenuController',
}

/**
 * Controller of component {@link tmrHelpMenu}.
 *
 * @type {ngController}
 */
export class tmrHelpMenuController {
  static ngType = 'controller'

  constructor(TmrAboutModal) {
    'ngInject'
    Object.assign(this, { content: contentTemplateUrl, TmrAboutModal })
  }
}
